import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import theme from '../../theme';

const TwitterWhite = (props: SvgIconProps) => {
  const [isHover, setIsHover] = React.useState(false);
  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...props}
    >
      <path
        d="M30.7072 9.70726L26.9367 13.4778C26.1838 22.2129 18.8173 29.0002 10 29.0002C8.18445 29.0002 6.68824 28.7123 5.5528 28.1446C4.63648 27.6865 4.26111 27.1947 4.16797 27.0549C4.08441 26.9295 4.03025 26.7869 4.00953 26.6377C3.9888 26.4885 4.00206 26.3366 4.0483 26.1932C4.09453 26.0498 4.17257 25.9188 4.27656 25.8098C4.38055 25.7008 4.50783 25.6167 4.64887 25.5638C4.68104 25.5517 7.62989 24.4191 9.53577 22.2627C8.35031 21.4186 7.30695 20.3909 6.44495 19.2184C4.73145 16.8929 2.9192 12.8545 4.01612 6.82127C4.04877 6.64172 4.12993 6.47453 4.2508 6.33781C4.37168 6.20109 4.52766 6.10005 4.70186 6.04564C4.87605 5.99123 5.06182 5.98552 5.23902 6.02914C5.41623 6.07275 5.57812 6.16403 5.70716 6.29307C5.75123 6.33702 9.91242 10.4394 14.9993 11.7646L15 10.9997C15.0108 9.3986 15.6568 7.8673 16.7962 6.74238C17.9356 5.61745 19.475 4.99096 21.0761 5.0006C22.1162 5.015 23.1348 5.29894 24.0324 5.82467C24.9299 6.3504 25.6758 7.09995 26.1971 8.00011L30 8.00017C30.1978 8.00017 30.3911 8.05882 30.5556 8.16869C30.72 8.27857 30.8482 8.43475 30.9239 8.61747C30.9996 8.80019 31.0194 9.00126 30.9808 9.19524C30.9422 9.38922 30.847 9.5674 30.7072 9.70726Z"
        fill={isHover ? theme.palette.cyan : theme.palette.greyscale.white}
      />
    </SvgIcon>
  );
};

export default TwitterWhite;
